<template>
    <div v-show="isPageReady" class="cropper__block">
        <div class="cropper__img-wrap">
            <img ref="img" :src="src" class="cropper__img" />
        </div>

        <div class="pt-3 d-flex flex-wrap">
            <button
                type="button"
                class="cabinet-btn mr-2 mb-2"
                @click="rotate(10)"
            >
                ↻
            </button>
            <button
                type="button"
                class="cabinet-btn mr-2 mb-2"
                @click="rotate(-10)"
            >
                ↺
            </button>
            <button
                type="button"
                class="cabinet-btn cropper__btn-zoom mr-2 mb-2"
                @click="zoom(0.01)"
            >
                +
            </button>
            <button
                type="button"
                class="cabinet-btn cropper__btn-zoom mr-2 mb-2"
                @click="zoom(-0.01)"
            >
                -
            </button>
            <button
                type="button"
                class="cabinet-btn ml-lg-auto"
                @click="getCroppedImg()"
            >
                Добавить
            </button>
        </div>
    </div>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import Cropper from 'cropperjs'
import { mapState } from 'vuex'

export default {
    name: 'Cropper',
    props: {
        src: {
            type: String,
            required: true
        },
        mime: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            cropper: ''
        }
    },
    computed: {
        //check if user loaded to set correct canvas size on mobile
        ...mapState('user', ['user']),
        isPageReady() {
            return this.user && !!Object.keys(this.user).length
        }
    },
    watch: {
        isPageReady(val, oldVal) {
            if (val && !oldVal) {
                this.init()
            }
        }
    },
    mounted() {
        if (this.isPageReady) {
            this.init()
        }
    },
    methods: {
        init() {
            this.cropper = new Cropper(this.$refs.img, {
                aspectRatio: 1 / 1,
                autoCropArea: 1,
                // minCropBoxWidth: 300,
                // minCropBoxHeight: 300,
                viewMode: 1,
                // zoom: 1,
                wheelZoomRatio: 0.05,
                cropBoxMovable: false,
                cropBoxResizable: false,
                dragMode: 'move',
                toggleDragModeOnDblclick: false,
                minContainerHeight: window.$('.cropper__img-wrap').width(),
                ready(e) {
                    // this.cropper.zoomTo(1)
                }
            })
        },
        rotate(deg) {
            this.cropper.rotate(deg)
        },
        zoom(k) {
            this.cropper.zoom(k)
        },
        move(x, y) {
            this.cropper.move(x, y)
        },
        getCroppedImg() {
            let result = this.cropper.getCroppedCanvas({
                // width: this.cropper.getCropBoxData().width,
                // height: this.cropper.getCropBoxData().height,
                minWidth: 0,
                minHeight: 0,
                maxWidth: 800,
                maxHeight: 800,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high',
                fillColor: '#ffffff'
            })

            let quality = 0.92

            let koef_w =
                this.cropper.getImageData().naturalWidth /
                this.cropper.getImageData().width
            let koef_h =
                this.cropper.getImageData().naturalHeight /
                this.cropper.getImageData().height

            if (koef_w < 1 || koef_h < 1) {
                quality = 1
            }

            let data = result.toDataURL(this.mime, quality)

            // console.log(result)
            // console.log(data)
            // console.log(quality)

            this.$emit('imgCropped', data)
        }
    }
}
</script>

<style lang="sass" scoped>
.cropper
    &__block
        width: 100%
        max-width: 500px
        overflow: hidden
    &__img
        display: block
        max-width: 100%
        &-wrap
            max-height: 500px
    &__btn
        &-zoom
            font-size: 18px
</style>
